import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Alliances from './components/Alliances';
import Contact from './components/Contact';
import Blog from './components/Blog';
import Footer from './components/Footer';
import SeoHead from '../../components/SeoHead';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'CJ Solutions Ltd',
    url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}`,
    logo: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/logo.png`,
    description: 'Expert compliance, AML, KYC, iGaming & Forex licensing, tax advisory, and company formation services in Limassol, Cyprus.',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Limassol',
      addressCountry: 'CY',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+357-95981879',
      contactType: 'customer service',
      email: 'info@cjsolutionsltd.com',
      availableLanguage: 'English',
    },
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'CJ Solutions Ltd',
    url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}`,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/resources?search={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'CJ Solutions Ltd',
    image: 'https://static.readdy.ai/image/9b819ec02f0cc35e99e8e09b39e5fe1e/4299ef1f9e55f3d4ef76bc3b6e5af17b.png',
    url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}`,
    telephone: '+357-95981879',
    email: 'info@cjsolutionsltd.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Limassol',
      addressCountry: 'CY',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 34.6841,
      longitude: 33.0379,
    },
    priceRange: '€€€',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'CJ Solutions Ltd',
    url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}`,
    telephone: '+357-95981879',
    email: 'info@cjsolutionsltd.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Limassol',
      addressRegion: 'Limassol District',
      addressCountry: 'CY',
    },
    areaServed: [
      { '@type': 'Place', name: 'Cyprus' },
      { '@type': 'Place', name: 'European Union' },
    ],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Compliance & Licensing Services',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'iGaming & Forex Licensing' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'AML & KYC Outsourcing' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Compliance Outsourcing' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Tax & Payroll Outsourcing' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Accounting Outsourcing' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Legal Drafting' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Company Formation' } },
      ],
    },
  },
];

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <SeoHead
        title="CJ Solutions | Compliance & Licensing Cyprus"
        description="CJ Solutions Ltd offers expert compliance, AML, KYC, iGaming & Forex licensing, tax advisory, and company formation services in Limassol, Cyprus."
        keywords="CJ Solutions, compliance consulting Cyprus, AML services Limassol, iGaming licensing, Forex license, KYC outsourcing"
        canonical="/"
        jsonLd={homeJsonLd}
      />
      <Header />
      <main>
        <Hero />
        <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 800px'}}>
          <AboutUs />
        </div>
        <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 900px'}}>
          <Services />
        </div>
        <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 600px'}}>
          <Testimonials />
        </div>
        <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 400px'}}>
          <Alliances />
        </div>
        <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 700px'}}>
          <Blog />
        </div>
        <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 500px'}}>
          <Contact />
        </div>
      </main>
      <Footer />
    </div>
  );
}
